import React from 'react';
import PropTypes from 'prop-types';
import { Video } from 'site-modules/shared/components/video/';
import { NativeVideoAd } from 'site-modules/shared/components/native-ad/video/video-native-ad';

import './inline-video-sponsor.scss';

export function InlineVideoSponsor({ videoId = '', playlistId = '', type = null, sponsorTitle = 'sponsored' }) {
  return (
    <div className="inline-video-sponsor d-flex pos-r flex-wrap flex-md-nowrap w-100">
      <div className="w-100 video-wrapper p-md-0 pe-md-1">
        <Video videoId={videoId} playlistId={playlistId} type={type} autoplay muted />
      </div>
      <div className="w-100">
        <div className="sponsor-title p-md-0 h4 fw-bold pt-1">{sponsorTitle}</div>
        <div className="adunit-wrapper">
          <NativeVideoAd />
        </div>
      </div>
    </div>
  );
}

InlineVideoSponsor.propTypes = {
  videoId: PropTypes.string,
  playlistId: PropTypes.string,
  type: PropTypes.string.isRequired,
  sponsorTitle: PropTypes.string.isRequired,
};
